/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/
import { cn } from '@/lib/utils'
import { SidebarTrigger } from '@/components/ui/sidebar'

type HeaderProps = React.HTMLAttributes<HTMLElement>

/**
 * Noya topbar — 54px white bar with 0.5px bottom border.
 * Contains sidebar toggle + right-side icon group (search/notify/lang/theme/avatar).
 */
export function Header({ className, children, ...props }: HeaderProps) {
  return (
    <header
      className={cn(
        'sticky top-0 z-40 h-[var(--app-header-height,3.375rem)] w-full shrink-0',
        'bg-card border-border border-b',
        className
      )}
      {...props}
    >
      <div className='flex h-full items-center gap-1.5 px-3 sm:gap-2 sm:px-4'>
        <SidebarTrigger
          variant='ghost'
          className='text-muted-foreground hover:bg-accent hover:text-accent-foreground size-8 rounded-md'
        />
        {children}
      </div>
    </header>
  )
}
